import styled from 'styled-components';
import { getSpace, px2rem, mq } from '../../../../stylesheets/tools';

const StyledEducationTabletFinished = styled.div`
  position: relative;
  margin: auto 0;

  .finished__content {
    padding: ${px2rem('140px')} 0 ${getSpace('xl')} 0;
    display: flex;
    flex-direction: column;
    gap: ${px2rem('20px')};
    text-align: center;
    align-items: center;

    ${mq('m')} {
      padding: ${px2rem('200px')} 0 ${getSpace('xl')} 0;
    }

    .finished__content-video {
      top: -10%;
      position: absolute;
      max-width: ${px2rem('280px')};
      z-index: -1;

      ${mq('m')} {
        top: 0;
      }
    }
  }
`;

export default StyledEducationTabletFinished;
